const viewStatisticsActionTypes = {
  GET_VIEW_STATISTICS_SUCCESS: "GET_VIEW_STATISTICS_SUCCESS",
  GET_VIEW_STATISTICS_FAILURE: "GET_VIEW_STATISTICS_FAILURE",
  GET_VIEW_STATISTICS_INITIAL: "GET_VIEW_STATISTICS_INITIAL",
  SET_VIEW_STATISTICS_FILTERS: "SET_VIEW_STATISTICS_FILTERS",
  SET_VIEW_STATISTICS_BILLERS: "SET_VIEW_STATISTICS_BILLERS",
};

export default viewStatisticsActionTypes;
